import { SpotlightType } from "./types";
import Button from "../Button";
import BackgroundVideo from "../BackgroundVideo";

export default function Spotlight({
  title,
  description,
  buttonLabel,
  onClick,
  source,
  fallbackImageSource,
  reverse,
  textTheme,
  bgColor,
}) {
  const mode = textTheme === "light" ? "text-black" : "text-white";
  const buttonStyle = textTheme === "light" ? "dark-outline" : "light-outline";

  return (
    <div
      className="relative flex flex-col lg:flex-row lg:h-screen-xs w-full rounded-lg overflow-hidden shadow-darkSM hover:shadow-darkLG"
      style={{ backgroundColor: `#${bgColor}` }}
    >
      <div
        className={`${
          reverse ? "order-first lg:order-last" : "order-first"
        } h-full w-full lg:w-3/5`}
      >
        <BackgroundVideo
          source={source}
          fallbackImage={{ sources: fallbackImageSource, alt: title }}
          className="object-cover w-full h-3xl sm:h-3xl lg:h-full"
        />
      </div>
      <div
        className={`${
          reverse ? "order-last lg:order-first" : "order-last"
        } flex flex-col justify-center items-start w-full lg:w-2/5 p-lg space-y-md`}
      >
        <p className={`gn-headline-lg ${mode}`}>{title}</p>
        <p className={`gn-text line-clamp-4 ${mode}`}>{description}</p>
        <Button
          mode={buttonStyle}
          size="md"
          onClick={onClick}
          label={buttonLabel}
        />
      </div>
    </div>
  );
}

Spotlight.propTypes = SpotlightType;

Spotlight.defaultProps = {
  textTheme: "dark",
  bgColor: "000",
};
